import React from 'react';

import SampleFeedItemsPanelContainer from 'buyside/components/container/Feed/SampleFeedItemsPanelContainer';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import FeedItemsPanelContainer from 'buyside/components/container/Feed/FeedItemsPanelContainer';
import ErrorMessage from 'buyside/components/presentation/ErrorMessage/errorMessage';

import { get } from 'buyside/util/lodashAltJs';

class ActivityFeedArea extends React.Component {
  constructor() {
    super();
  }

  recordOnboardingClick() {
    if (window.hj) {
      window.hj('tagRecording', ['activity_feed_onboarding_click']);
    }
  }

  render() {
    const { currentUser, feedId, showPostSubmission } = this.props;

    if (window.hj && currentUser && currentUser.id) {
      window.hj('tagRecording', [`user_${currentUser.id}`]);
    }
    if (window.hj && currentUser && !currentUser.hasCompletedOnboarding) {
      window.hj('tagRecording', ['activity_feed_no_onboarding']);
    }
    if (!currentUser) {
      return (
        <ErrorMessage title="Uh Oh...">
          There was a problem loading your feed. Please refresh the page. If the problem persists
          contact <a href="mailto:support@sumzero.com">support@sumzero.com</a>.
        </ErrorMessage>
      );
    }
    return (
      <div>
        {!currentUser.hasCompletedOnboarding ? (
          <SampleFeedItemsPanelContainer
            currentUser={currentUser}
            showPostSubmission={showPostSubmission}
          />
        ) : (
          <ErrorBoundary pageName="your feed">
            <FeedItemsPanelContainer
              currentUser={currentUser}
              employerProfileId={get(currentUser, 'fundProfile.id')}
              feedId={feedId}
              showPostSubmission={showPostSubmission}
              showUpdateSubscriptionsFeedItem={this.props.showUpdateSubscriptionsFeedItem}
            />
          </ErrorBoundary>
        )}
      </div>
    );
  }
}

export default ActivityFeedArea;
